export default {

    sessionStorage()
    {

    },

    localStorage(opts)
    {
        debugger;
        var config = Object.assign({
            namespace : "settings",
            key : null,
            defaultValue : null,
        },opts);

        //exists
        var get = function() {
            debugger;
            var result = !!localStorage.getItem(config.namespace)
                ? JSON.parse(localStorage.getItem(config.namespace))
                : {};

            return !!result[config.key]
                ? result[config.key]
                : config.defaultValue;

        };
        var set = function(val) {
            try
            {
                var result = !!localStorage.getItem(config.namespace)
                ? JSON.parse(localStorage.getItem(config.namespace))
                : {};
                result[config.key] = val;
                localStorage.setItem(config.namespace, JSON.stringify(result));
                return true;
            }
            catch(ex)
            {
                console.error(ex);
                return false;
            }
        };

        return   { name: config.namespace, get, set };
        
    },

    
    getLocalStorage(key, fallbackValue)
    {
        return () => { 
            return window.localStorage.getItem(key) || fallbackValue;
        }
    },
    getLocalStorageBoolean(key, fallbackValue)
    {
        return () => { 
            var result = window.localStorage.getItem(key)
            return  !!(result) ? result == "true" : (fallbackValue || null);
        }
    },
    getLocalStorageFloat(key, fallbackValue)
    {
        return () => { 
            var result = window.localStorage.getItem(key)
            return  !!(result) ? parseFloat(result) : (fallbackValue || null);
        }
    },
    getLocalStorageJson(key, fallbackValue)
    {
        return () => { 
            var result = window.localStorage.getItem(key);
            try
            {
                return !!result ? JSON.parse(result) : fallbackValue;
            }
            catch(err)
            {
                return fallbackValue
            }
        }
    },
    setLocalStorage(key)
    {
        return (value) => { 
            return window.localStorage.setItem(key,value);
        }
    },
    setLocalStorageJson(key)
    {
        return (value) => { 
            return window.localStorage.setItem(key,JSON.stringify(value));
        }
    },
    setLocalStorageJsonTest(key)
    {
        // debugger;
        return (value) => {
            // debugger;
            return window.localStorage.setItem(key,JSON.stringify(value));
        }
    }

}